import { Badge, IconButton, useTheme } from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import { useReduxState } from "../../../../../explorer/redux/hooks";
import { reduxStoreConfig } from "../../../../configuration/reduxStoreConfig";
import { Basket } from "../../../../../explorer/types";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { AppIconsCart } from "../../../AppIcons";
import {} from "./AppBasketMenu.styles";
import { CommonSnackbar } from "../../../../../explorer/components/SnackBar/CommonSnackbar";
import { CreateBasketDialog } from "./BasketListCreateDialog";
import { BasketListDotsMenu } from "./BasketListDotsMenu";
import useBrands from "../../../../../explorer/hooks/useBrands";
import { AppBasketMenuList } from "./AppBaskeMenuList2";
import { useBasket } from "../../../../hook/useBasket";
import { RenameBasketDialog } from "./BasketListRenameDialog";
import { DeleteBasketDialog } from "./BasketListDeleteDialog";

export function AppBasketMenu() {
    const [
        basketActionResultSnackbarState,
        setBasketActionResultSnackbarState,
    ] = React.useState({ open: false, isError: false, message: "" });

    const [loading, setLoading] = React.useState<boolean>(false);
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);
    const [selectedBasketInfo, setSelectedBasketInfo] = React.useState<{
        id: number | null;
        name: string | null;
    }>({ name: null, id: null });

    const basketOperation = useBasket();
    const brand = useBrands().currentBrandUrl;

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);

    const { t } = useTranslation();

    const [nItemsRef, setNItemsRef] = useState<number>();

    useEffect(() => {
        if (isMenuOpen) {
            setLoading(true);
            //basketOperation.loadBaskets();
            basketOperation.reloadBaskets(brand);
            setLoading(false);
        }
    }, [isMenuOpen]);

    useEffect(() => {
        if (Object.keys(basketOperation.currentBasket).length > 0)
            setNItemsRef(basketOperation.currentBasket.nItems);
    }, [basketOperation.currentBasket]);

    const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);

    };

    const handleMenuClose = () => {
        
        setAnchorEl(null);
    };

    const handleMenuCloseOnChange = (basket: Basket) => {
        basketOperation.changeCurrentBasket(basket.id!);
        handleMenuClose();
    };

    // ---------------
    // Activation menu
    // ---------------
    const [basketListActionAnchorEl, setBasketListActionAnchorEl] =
        React.useState<HTMLButtonElement | null>(null);

    const [showDeleteButton, setShowDeleteButton] =
        React.useState<boolean>(false);

    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [renameDialogOpen, setRenameDialogOpen] = React.useState(false);

    const handleActivateActionMenu = (
        event: any,
        basketId: number,
        basketName: string,
        showDelete: boolean
    ) => {
        setBasketListActionAnchorEl(event.target);
        setSelectedBasketInfo({ name: basketName, id: basketId });
        setShowDeleteButton(showDelete);
        event.preventDefault();
        event.stopPropagation();
    };

    const handleCloseDotsPopup = () => {
        setBasketListActionAnchorEl(null);
    };

    // ---------------
    // Basket Rename
    // ---------------

    const handleRenameBasket = () => {
        setRenameDialogOpen(true);
        return false;
    };

    const handleRenameBasketConfirm = async (id: number, name: string) => {
        // setRenameDialogOpen(false);
        // if (basketOperation.renameBasket(id, name)) {
        //     setBasketActionResultSnackbarState({
        //         open: true,
        //         isError: false,
        //         message: t("common.spareparts.basket_renamed") as string,
        //     });
        // } else {
        //     setBasketActionResultSnackbarState({
        //         open: true,
        //         isError: true,
        //         message: t("common.spareparts.basket_rename_error") as string,
        //     });
        // }
        // setRenameDialogOpen(false);
        // return false;


        setLoading(true);

        const resultSnack = await basketOperation.renameBasket(id, name);
        if (resultSnack && resultSnack.isError !== true)  {
            setRenameDialogOpen(false);
        }
        setBasketActionResultSnackbarState(resultSnack);
        setLoading(false);


    };

    // ---------------
    // Basket Delete
    // ---------------
    const handleDeleteBasket = () => {
        setDeleteDialogOpen(true);
    };
    const handleDeleteBasketConfirm = (id: number) => {
        if (basketOperation.deleteBasket(id)) {
            setBasketActionResultSnackbarState({
                open: true,
                isError: false,
                message: t("common.spareparts.basket_deleted") as string,
            });
        } else {
            setBasketActionResultSnackbarState({
                open: true,
                isError: true,
                message: t("common.spareparts.basket_deleted_error") as string,
            });
        }
        setDeleteDialogOpen(false);
        return false;
    };

    // ---------------
    // Basket create
    // ---------------

    const handleCreateBasketConfirm = async (name: string) => {
        setLoading(true);

        const resultSnack = await basketOperation.createBasket(name);
        if (resultSnack && resultSnack.isError !== true)  {
            setCreateDialogOpen(false);
        }
        setBasketActionResultSnackbarState(resultSnack);
        setLoading(false);
    };

    // ---------------
    // Select basket
    // ---------------
    const handleChangeCurrentBasket = (event: any, basketId: number) => {
        event.preventDefault();
        event.stopPropagation();
        basketOperation.changeCurrentBasket(basketId);
        return false;
    };

    const menuId = "primary-search-account-menu";

    return (
        <React.Fragment>
            <IconButton
                className="AppBasketMenu-icon"
                size="large"
                // edge="end"
                aria-label="Basket"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleMenuOpen}
                color="inherit"
            >
                <Badge>
                    <AppIconsCart />
                </Badge>
            </IconButton>
            <AppBasketMenuList
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                handleActivateActionMenu={handleActivateActionMenu}
                menuId={menuId}
                isMenuOpen={isMenuOpen}
                handleMenuClose={handleMenuClose}
                handleMenuCloseOnChange={handleMenuCloseOnChange}
                loading={loading}
                setLoading={setLoading}
                setBasketActionResultSnackbarState={
                    setBasketActionResultSnackbarState
                }
                setCreateDialogOpen={setCreateDialogOpen}
            />
            <BasketListDotsMenu
                anchorElement={basketListActionAnchorEl}
                showDelete={showDeleteButton}
                onRenameBasket={handleRenameBasket}
                onDeleteBasket={handleDeleteBasket}
                onClose={handleCloseDotsPopup}
            />
            <CreateBasketDialog
                name={""}
                open={createDialogOpen}
                onClose={(val: boolean) => {
                    setCreateDialogOpen(false);
                }}
                onCreate={handleCreateBasketConfirm}
            />
            <RenameBasketDialog
                name={selectedBasketInfo.name as string}
                basketId={selectedBasketInfo.id as number}
                defaultOpen={renameDialogOpen}
                onClose={(val: boolean) => {
                    setRenameDialogOpen(val);
                }}
                onRename={handleRenameBasketConfirm}
            />
            <DeleteBasketDialog
                defaultOpen={deleteDialogOpen}
                basketId={selectedBasketInfo.id as number}
                onClose={(val: boolean) => {
                    setDeleteDialogOpen(val);
                }}
                onDelete={handleDeleteBasketConfirm}
            />
            <CommonSnackbar
                messageType={basketActionResultSnackbarState.isError ? "error" : "success"}
                message={basketActionResultSnackbarState.message}
                onClose={() => {
                    setBasketActionResultSnackbarState({
                        ...basketActionResultSnackbarState,
                        open: false,
                    });
                }}
                open={basketActionResultSnackbarState.open}
            />
        </React.Fragment>
    );
}
